exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-modal[data-v-03649a5a] {\n  padding: 2vmin;\n}\n@media screen and (min-width: 896px) {\n.product-modal[data-v-03649a5a] {\n    max-height: 80vh!important;\n    overflow: scroll;\n}\n}\n@media screen and (max-width: 895px) {\n.product-modal[data-v-03649a5a] {\n    height: 90vh!important;\n    overflow: scroll;\n}\n}\n", ""]);

// exports
